export default __webpack_public_path__ + "ea6a569f97e056085ad257d9f2acec7e.png";